import { writable } from "svelte/store"


export const newAlert = writable({
    notice: false,
})




